import { compose, fromRenderProps } from 'recompose';

import JourneyCardContext from './journeyCardContext';

const enhance = compose(
  fromRenderProps(JourneyCardContext.Consumer, (selectors) => {
    return { selectors };
  })
);

export default enhance;
